module.exports = __webpack_public_path__ + "static/media/Luxio_gaussian2.9eeb7f29.png";